var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareCreateQrcodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/\u751F\u6210\u4E8C\u7EF4\u7801") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8BE6\\u60C5-\\u5206\\u4EAB",
    transform: "translate(-141.000000, -565.000000)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(0.000000, 474.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(127.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6",
    transform: "translate(14.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.46153846,4.92307692 L4.92307692,4.92307692 L4.92307692,2.46153846 L2.46153846,2.46153846 L2.46153846,4.92307692 Z M0,16 L7.38461538,16 L7.38461538,8.61538462 L0,8.61538462 L0,16 Z M1.23076923,9.84615385 L6.15384615,9.84615385 L6.15384615,14.7692308 L1.23076923,14.7692308 L1.23076923,9.84615385 Z M2.46153846,13.5384615 L4.92307692,13.5384615 L4.92307692,11.0769231 L2.46153846,11.0769231 L2.46153846,13.5384615 Z M8.61538462,0 L8.61538462,7.38461538 L16,7.38461538 L16,0 L8.61538462,0 Z M14.7692308,6.15384615 L9.84615385,6.15384615 L9.84615385,1.23076923 L14.7692308,1.23076923 L14.7692308,6.15384615 Z M14.7692308,11.0769231 L12.3076923,11.0769231 L12.3076923,8.61538462 L9.84615385,8.61538462 L8.61538462,8.61538462 L8.61538462,11.0769231 L8.61538462,16 L9.84615385,16 L9.84615385,11.0769231 L11.0769231,11.0769231 L11.0769231,12.3076923 L14.7692308,12.3076923 L16,12.3076923 L16,8.61538462 L14.7692308,8.61538462 L14.7692308,11.0769231 Z M0,7.38461538 L7.38461538,7.38461538 L7.38461538,0 L0,0 L0,7.38461538 Z M1.23076923,1.23076923 L6.15384615,1.23076923 L6.15384615,6.15384615 L1.23076923,6.15384615 L1.23076923,1.23076923 Z M13.5384615,2.46153846 L11.0769231,2.46153846 L11.0769231,4.92307692 L13.5384615,4.92307692 L13.5384615,2.46153846 Z M14.7692308,16 L16,16 L16,13.5384615 L14.7692308,13.5384615 L14.7692308,16 Z M12.3076923,16 L13.5384615,16 L13.5384615,13.5384615 L12.3076923,13.5384615 L12.3076923,16 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareCreateQrcodeIcon);
export default __webpack_public_path__ + "static/media/share-create-qrcode-icon.66d3493a56745e1af27fe9639514443f.svg";
export { ForwardRef as ReactComponent };